import React, { useEffect, useState } from 'react';

export const Popup = (props) => {

    const [active, setActive] = useState(false)
    const [show, setShow] = useState(false)

    useEffect(() => {
        if (props.active) {
            setActive(true)
            setTimeout(() => {
                setShow(true)
            }, 350);
        } else {
            setShow(false)
            setTimeout(() => {
                setActive(false)
            }, 350);
        }
    }, [props.active])

    return (
        <>
            <div className={`popup-smsng ${active ? 'active' : ''} ${show ? 'show' : ''} ${props.classes}`}>
                <div className="overlay"></div>
                <div className="inner-popup">
                    {props.children}
                </div>
            </div>
        </>
    );
}